import { useAuthenticatedMutation } from "@l2r-front/l2r-auth"

export function useDocumentMutation(
    url,
    axiosFn,
    queryParameters,
    config = {},
) {
    const apiUrl = `document/${url}`

    return useAuthenticatedMutation(
        apiUrl,
        axiosFn,
        queryParameters,
        config,
    )
}